import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Input } from 'sfy-react'
import styles from '../../../routes/Login/Login.module.scss'
import { setFields } from '../../../redux/login'
import { ReactComponent as Email } from '../../../assets/images/email.svg'
import { setLoader, setSnackbar } from '../../../redux/common'
import { setConsumerDetails, setUserDetails } from '../../../redux/user'
import { useNavigate } from 'react-router-dom'

const LoginForm = ({ isDisabled }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const translatedData = useSelector((state) => state.common.translatedData)
  const appConfigDetails = useSelector((state) => state.common.appConfigDetails)
  const fields = useSelector((state) => state.login.fields)

  useEffect(() => {
    const fields = { email: '', password: '', consent: true }
    dispatch(setFields(fields))
  }, [appConfigDetails, dispatch])

  const handleOnChange = (e) => {
    dispatch(setFields({ [e.target.name]: e.target.value }))
  }

  const handleOnSubmit = (e) => {
    try {
      e.preventDefault()
      dispatch(setLoader(true))
      const userDetails = window.userList.find((user) => user.emailID === fields.email && user.password === fields.password)
      if (userDetails) {
        sessionStorage.setItem('consumerID', userDetails.consumerID)
        sessionStorage.setItem('authorization', '47d31ae2-414e-4206-8514-bd991c0e6917')
        dispatch(
          setConsumerDetails({
            consumerID: userDetails.consumerID,
            accessToken: {
              ID: '47d31ae2-414e-4206-8514-bd991c0e6917',
              consumerID: 123456,
            },
          })
        )
        dispatch(setUserDetails(userDetails))
        dispatch(setLoader(false))
        navigate('/home')
      } else {
        throw new Error('Invalid Credentials')
      }
    } catch (e) {
      console.log(e)
      dispatch(setSnackbar({ message: e.msg || e.message, type: 'error' }))
      dispatch(setLoader(false))
    }
  }

  return (
    <>
      <form onSubmit={handleOnSubmit} className={styles['form']}>
        <Input
          name='email'
          value={fields.email || ''}
          className={{ formControl: 'mt24 mb20', label: 'input__label f14 semi-bold-font', input: 'pl0' }}
          placeholder={translatedData.login.enterEmailID}
          label={translatedData.common.emailId}
          handleOnChange={handleOnChange}
        >
          <Email className='value-component-image' />
        </Input>
        <Input
          name='password'
          value={fields.password || ''}
          className={{ formControl: 'mt24 mb20', label: 'input__label f14 semi-bold-font' }}
          placeholder={translatedData.common.enterPassword}
          label={translatedData.common.password}
          handleOnChange={handleOnChange}
          otherProps={{ type: 'password' }}
        ></Input>
        <div className={appConfigDetails.isSSOEnabled ? '' : styles['bottom-container']}>
          <Button className={`button ${appConfigDetails.isSSOEnabled ? styles['button-sso'] : 'button-primary'}`} isDisabled={isDisabled}>
            {appConfigDetails.isSSOEnabled ? (
              <div className={styles['button-sso-container']}>
                Login via <img className='pl5' src={`/${window.appName}/images/sso-logo.png`} alt='sso-logo' />
              </div>
            ) : (
              translatedData.login.signIn
            )}
          </Button>
        </div>
      </form>
    </>
  )
}

export default LoginForm
